import { USERS_LIST_ACTION, ADD_USER_ACTION,UPDATE_USER  } from "../Actions/UserListAction";

const initialstate={usersList:[]};

const usersListReducer = (state=initialstate,action)=>{
    switch(action.type){
        case  USERS_LIST_ACTION:
            return{
                ...state,
                usersList:  action.payload,
                // usersList:  [...state.usersList, action.payload],
            };
            case ADD_USER_ACTION:
            return {
                ...state,
                usersList: [...state.usersList, action.payload],  // Add new user to the list
            }; 
            case UPDATE_USER:
                return {
                  ...state,
                  usersList: state.usersList.map(user =>
                    user.profileId === action.payload.profileId
                      ? {  ...action.payload } // Update the existing user
                      : user
                  ),
                };
          
                
            default:
                return state
    }
}


export default usersListReducer;


